module.exports = __webpack_public_path__ + "static/img/tranChai.8b0c95f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tranChai.jpg
// module id = w7Ex
// module chunks = 1